<template>
    <div class="layout__container">

        <!--{{this.orders[0]}}-->

        <div class="layout__width-100 layout__padding-clear">
            <div class="">

                <h2 class="text__align-center text__colour-teal layout__margin-20-0">Admin Orders Search</h2>

                <div class="layout__position-left layout__width-100">
                    <AdminOrdersSearch ref="adminSearch" v-bind:searchParams="searchParams" v-bind:orders="orders"
                                       v-bind:loading="loading" v-bind:resultsCount="resultsCount"></AdminOrdersSearch>
                </div>

                <div class="layout__width-100 layout__position-left">
                    <el-table :data="orders"
                              class="layout__height-600px layout__scrolling__right layout__padding-0-40px"
                              v-loading.fullscreen.lock="loading">
                        <!-- v-on:row-click="viewOrders" todo to be added in when fixed -->
                        <el-table-column prop="orderId" label="Customer Id" width="110">
                        </el-table-column>
                        <el-table-column prop="ordered" label="Ordered" width="120" :formatter="formatDateDDMMYYYY">
                        </el-table-column>
                        <el-table-column prop="sourceId" label="Source Id" width="120">
                        </el-table-column>
                        <el-table-column prop="jobId" label="PDC Id" width="120">
                        </el-table-column>
                        <el-table-column prop="type" label="Type" width="140">
                        </el-table-column>
                        <el-table-column prop="productCat1" label="Category" width="140">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="140">
                        </el-table-column>
                        <el-table-column prop="branch" label="Branch" width="100">
                        </el-table-column>
                        <el-table-column prop="name" label="Name" width="300">
                        </el-table-column>
                        <el-table-column prop="jobName" label="Job Name" width="540" class="text__wordwrap">
                        </el-table-column>
                        <el-table-column prop="quantity" label="Qty" width="100">
                        </el-table-column>
                        <el-table-column prop="billNetTotal" label="Value" width="100"
                                         :formatter="returnFormattedCurrencyGrid">
                        </el-table-column>
                        <el-table-column prop="billStatus" label="Bill Status" width="200">
                        </el-table-column>
                        <el-table-column prop="customer.territory" label="Territory" width="240">
                        </el-table-column>
                    </el-table>
                </div>

                <!--<Pagination v-bind:orders="orders" v-bind:start="start" v-bind:end="end"-->
                            <!--v-bind:pagination="pagination"></Pagination>-->

                    <div class="layout__padding-clear layout__width-60">
                        <div class="layout__padding-20-0">
                            <el-pagination class=""
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"
                                           :current-page="this.searchParams.currentPage"
                                           :page-sizes="[20, 40, 60, 80, 100]"
                                           :page-size="this.searchParams.pagination"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="this.resultsCount">
                            </el-pagination>
                        </div>
                    </div>
                </div>

        </div>
    </div>

</template>

<script>

    import AdminOrdersSearch from '../../components/search/AdminOrdersSearch.vue';
    import {axios} from '@/mixins/Axios.js';
    import {pagination} from '@/mixins/Pagination.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Pagination from "../../components/Pagination";

    export default {
        name: "orders",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            Pagination,
            AdminOrdersSearch,
        },
        data() {
            return {
                resultsCount: '',
                orders: [],
                loading: false,
                currentpage: 3,
                searchParams: {
                    orderSource: 'ANY PRODUCT',
                    orderCategory: 'ANY CATEGORY',
                    orderSourceId: null,
                    orderStatus: 'ANY STATUS',
                    orderFreeText: '',
                    dateFilter: 'ORDERED',
                    assignment: null,
                    territory: null,
                    top: 20,
                    pagination: 20,
                    skip: 0,
                    currentPage: 1,
                    salesDateRange: []
                }
            }
        },
        created() {
            this.isUserAuthorised();
        },
        beforeUpdate() {
            // todo do I need this here?
            window.sessionStorage.setItem('_adminOrdersSearch', JSON.stringify(this.searchParams));
        },
        methods: {
            viewOrders(order) {
                console.log('order before drilldown')
                console.log(order)
                this.$router.push({
                    name: '/admin/orders/details',
                    query: {
                        source: order.source,
                        id: order.sourceId,
                    }
                })
            },
            resultsPerPage() {
                this.$refs.adminSearch.adminSearchPagination();
            },
            csv() {
                // todo this needs to be called like the above
                document.getElementById('downloadAllResults').click()
            }

        }
    };
</script>